<template>
  <div class="works-component rock">
    <div class="banner"> 
      <img src="../../../assets/img/works/link-house-condo/10-石-ROCK-KM1-BUKIT JALIL/00-hero banner.jpg" alt="">
    </div>
    <div class="border-bottom-1px">
      <div class="container ">
        <p class="playfair playfair-display-sm-400 black text-left m-0">
          石 | Rock
        </p>
      </div>
    </div>
    <div class="container p-112 works-img border-bottom-1px"> 
      <b-row sm>
        <b-col md="6" sm>
          <img  :src="require('@/assets/img/works/link-house-condo/10-石-ROCK-KM1-BUKIT JALIL/01-landscape-lift-1.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(0)" > 
        </b-col>
        <b-col md="6" sm>
          <img  :src="require('@/assets/img/works/link-house-condo/10-石-ROCK-KM1-BUKIT JALIL/01-landscape-lift-2.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(1)" >
        </b-col> 
      </b-row>
      <b-row sm>
        <b-col>
          <img  :src="require('@/assets/img/works/link-house-condo/10-石-ROCK-KM1-BUKIT JALIL/02-full-liv-1.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(2)" >
        </b-col>
      </b-row>
      <b-row sm>
        <b-col md="4" sm>
          <img  :src="require('@/assets/img/works/link-house-condo/10-石-ROCK-KM1-BUKIT JALIL/03-landscape-liv-1.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(3)" >
        </b-col>
        <b-col md="4" sm>
          <img  :src="require('@/assets/img/works/link-house-condo/10-石-ROCK-KM1-BUKIT JALIL/03-landscape-liv-2.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(4)" >
        </b-col>
        <b-col md="4" sm>
          <img  :src="require('@/assets/img/works/link-house-condo/10-石-ROCK-KM1-BUKIT JALIL/03-landscape-liv-3.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(5)" >
        </b-col>
      </b-row>
      <b-row sm>
        <b-col md="6" sm>
          <img  :src="require('@/assets/img/works/link-house-condo/10-石-ROCK-KM1-BUKIT JALIL/04-landscape-liv-1.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(6)" >
        </b-col>
        <b-col md="6" sm>
          <img  :src="require('@/assets/img/works/link-house-condo/10-石-ROCK-KM1-BUKIT JALIL/04-landscape-liv-2.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(7)" >
        </b-col> 
      </b-row>
      <b-row sm>
        <b-col md="4" sm>
          <img  :src="require('@/assets/img/works/link-house-condo/10-石-ROCK-KM1-BUKIT JALIL/05-landscape-dry-1.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(8)" >
        </b-col>
        <b-col md="4" sm>
          <img  :src="require('@/assets/img/works/link-house-condo/10-石-ROCK-KM1-BUKIT JALIL/05-landscape-dry-2.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(9)" >
        </b-col>
        <b-col md="4" sm>
          <img  :src="require('@/assets/img/works/link-house-condo/10-石-ROCK-KM1-BUKIT JALIL/05-landscape-dry-3.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(10)" >
        </b-col>
      </b-row> 
      <b-row sm>
        <b-col md="6" sm>
          <img  :src="require('@/assets/img/works/link-house-condo/10-石-ROCK-KM1-BUKIT JALIL/06-portrait-1.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(11)" >
        </b-col>
        <b-col md="6" sm>
          <img  :src="require('@/assets/img/works/link-house-condo/10-石-ROCK-KM1-BUKIT JALIL/06-portrait-2.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(12)" >
        </b-col> 
      </b-row>  
      <b-row sm>
        <b-col md="4" sm>
          <img  :src="require('@/assets/img/works/link-house-condo/10-石-ROCK-KM1-BUKIT JALIL/07-landscape-master-1.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(13)" >
        </b-col>
        <b-col md="4" sm>
          <img  :src="require('@/assets/img/works/link-house-condo/10-石-ROCK-KM1-BUKIT JALIL/07-landscape-master-2.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(14)" >
        </b-col> 
        <b-col md="4" sm>
          <img  :src="require('@/assets/img/works/link-house-condo/10-石-ROCK-KM1-BUKIT JALIL/07-landscape-master-3.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(15)" >
        </b-col> 
      </b-row>   
    </div>
    <div class="container p-112 works-img">
      <b-row >
        <b-col md="4" class="pb-24"> 
          <b-row class="flex-center">
            <b-col cols="3" to="Rock"  tag="router-link"><img class="icon-expand cursor-pointer" src="../../../assets/img/icon/expand_circle_left.svg"></b-col>
            <b-col cols="9" class="text-right">
              <p class="inter inter-body-md-600 black  p-0">PREVIOUS PROJECT</p>
              <p class="playfair playfair-title-lg-400 black p-0">色彩生活 | Colours</p>
              <p class="inter inter-body-md-400 black p-0">Semanja Kajang | Kajang</p>
            </b-col> 
          </b-row>
        </b-col>
        <b-col md="4" sm> 
        </b-col>
        <!-- <b-col md="4" sm> 
          <b-row class="flex-center">
            <b-col cols="9" class="text-left">
              <p class="inter inter-body-md-600 black  p-0">NEXT PROJECT</p>
              <p class="playfair playfair-title-lg-400 black p-0">石 | Rock</p>
              <p class="inter inter-body-md-400 black p-0">KM1 | Bukit Jalil</p>
            </b-col>
            <b-col cols="3"  to="Rock"  tag="router-link"><img class="icon-expand cursor-pointer" src="../../../assets/img/icon/expand_circle_right.svg" alt=""></b-col>
          </b-row>
          
        </b-col> -->
      </b-row>
    </div>
    <GlobalLightbox
      :visible.sync="lightboxVisible"
      :images="resolvedImages"
      :index="currentIndex"
    />
  </div>

</template>

<script>
import GlobalLightbox from "@/components/GlobalLightbox.vue";
export default {
  name: 'rockLinkHouse',
    components: { GlobalLightbox },
data() {
    return { 
      basePath: "@/assets/img/works/link-house-condo/10-石-ROCK-KM1-BUKIT JALIL",
      images: [ 
        "01-landscape-lift-1.jpg",
        "01-landscape-lift-2.jpg",
        "02-full-liv-1.jpg",
        "03-landscape-liv-1.jpg",
        "03-landscape-liv-2.jpg",
        "03-landscape-liv-3.jpg",
        "04-landscape-liv-1.jpg",
        "04-landscape-liv-2.jpg",
        "05-landscape-dry-1.jpg",
        "05-landscape-dry-2.jpg",
        "05-landscape-dry-3.jpg",
        "06-portrait-1.jpg",
        "06-portrait-2.jpg",
        "07-landscape-master-1.jpg",
        "07-landscape-master-2.jpg",
        "07-landscape-master-3.jpg"
      ],
      lightboxVisible: false,
      currentIndex: 0

    }
  },
  computed: {
      resolvedImages() {
       return this.images.map(img => 
        require(`@/assets/img/works/link-house-condo/10-石-ROCK-KM1-BUKIT JALIL/${img}`)
      );
    }
    },
    methods: { 
      showLightbox(index) {
        this.currentIndex = index;
        this.lightboxVisible = true;
      }
    }, 

}
</script>

<style>
 
.rock{
  background-color: #D9D9D9  !important;
}
.banner img, .works-img img{
  width: 100%;
}
.works-img img{
  padding-bottom: 24px;
}
.rock p {
  padding: 24px 0;  
}
.p-112{
  padding: 112px 0 88px;
}
.works-component .amalfi-coast-title {
  padding-bottom: 4rem;
}

.letter-spacing {
  letter-spacing: 0.5em;
  padding-bottom: 56px
}
img.icon-expand{
  width: auto;
}

@media (max-width: 576px) { 
}
</style>